import { render } from "./EditFacebookPage.vue?vue&type=template&id=075167d1&scoped=true"
import script from "./EditFacebookPage.vue?vue&type=script&lang=js"
export * from "./EditFacebookPage.vue?vue&type=script&lang=js"

import "./EditFacebookPage.vue?vue&type=style&index=0&id=075167d1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075167d1"]])

export default __exports__